module.exports = __webpack_public_path__ + "static/media/apple-icon.a22eea42.svg";